"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// We want an 8 character base32-encoded value, so we set the beginning
// of time to a value a little more than 32^7 milliseconds ago, or a little
// over a year before we are generating the first id.
// This will remain 8 characters until we hit 32^8, or ~35 years.
// THIS VALUE MUST NEVER BE CHANGED. USING AN EARLIER SEED WOULD CAUSE
// POTENTIALLY DUPLICATE IDS TO BE GENERATED.
const beginningOfTime = new Date('2016-01-01T00:00:00Z').valueOf();
// To reduce conflicts generated in the same millisecond, we append
// a random value. 32^4 gives us a random number from 0 to ~1 million.
const randomDigits = 4;
const maxRandomValue = Math.pow(2, 5 * randomDigits);
// num.toString(32) produces base32-encoded values using 0-9 and a-v (first 22 letters).
// We drop the confusing letters ilos and add wxyz.
// To get monotonically increasing values, we can't directly replace just those 4 letters.
// We have to replace all letters after i.
// abcdefghijklmnopqrstuv in the original, become:
// abcdefghjkmnpqrtuvwxyz
const replaceOnGenerate = {
    i: 'j',
    j: 'k',
    k: 'm',
    l: 'n',
    m: 'p',
    n: 'q',
    o: 'r',
    p: 't',
    q: 'u',
    r: 'v',
    s: 'w',
    t: 'x',
    u: 'y',
    v: 'z',
};
// In the opposite direction, humans may see a 1, 0 or 5 as I, l, O or S.
const replaceOnClean = { i: '1', l: '1', o: '0', s: '5' };
exports.default = {
    // Generates an id in the form:
    // - Base32-encoded value of milliseconds since beginningOfTime.
    // - Appending a base32-encoded random value to reduce conflicts.
    generateBase32Id() {
        let randomSuffix = Math.floor(Math.random() * maxRandomValue).toString(32);
        while (randomSuffix.length < randomDigits) {
            randomSuffix = '0' + randomSuffix;
        }
        const msSinceBeginningOfTime = Date.now().valueOf() - beginningOfTime;
        const timestamp = msSinceBeginningOfTime.toString(32);
        const id = timestamp + randomSuffix;
        // @ts-ignore
        const result = id.replace(/[ijklmnopqrstuv]/g, (match) => replaceOnGenerate[match]);
        return result;
    },
    // In a human-entered id, we replace the confusing letters
    // with the values they were probably intended to be.
    cleanBase32Id(id) {
        // @ts-ignore
        return id.replace(/[ilos]/gi, (match) => replaceOnClean[match]);
    },
};
//# sourceMappingURL=idUtil.js.map